import React from 'react';
import { Switch } from 'react-router-dom';

import Route from './Route';

import SignIn from '~/pages/SignIn';
import Dashboard from '~/pages/Dashboard';
import Profile from '~/pages/Profile';
import Company from '~/pages/Company';
import CompanyProduct from '~/pages/CompanyProduct';
import Installation from '~/pages/Installation';
import Updates from '~/pages/Updates';
import UpdatesProduct from '~/pages/UpdatesProduct';
import UpdateProduct from '~/pages/UpdateProduct';
import CompanyActivity from '~/pages/CompanyActivity';

const Routes = () => {
  return (
    <Switch>
      <Route path="/" exact component={SignIn} />

      <Route path="/dashboard" exact component={Dashboard} isPrivate />
      <Route path="/updates" exact component={Updates} isPrivate />
      <Route
        path="/updates/:id/product"
        exact
        component={UpdatesProduct}
        isPrivate
      />
      <Route
        path="/updates/:product_id/product/:id"
        exact
        component={UpdateProduct}
        isPrivate
      />
      <Route path="/profile" exact component={Profile} isPrivate />
      <Route path="/company/:id" exact component={Company} isPrivate />
      <Route
        path="/company-activity/:id"
        exact
        component={CompanyActivity}
        isPrivate
      />
      <Route
        path="/company/:companyId/product/:id"
        exact
        component={CompanyProduct}
        isPrivate
      />
      <Route
        path="/company/:companyId/product/:companyProductId/installation/:id"
        exact
        component={Installation}
        isPrivate
      />
      <Route isPrivate notFound />
    </Switch>
  );
};

export default Routes;
